// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1962Q","colBig":"styles_colBig__13hzw","colSmall":"styles_colSmall__rJrc6"};